// extracted by mini-css-extract-plugin
module.exports = {"grid":"persona_grid__jwVAY","sidebar":"persona_sidebar__MFjUu","image":"persona_image__T2Vzc","title":"persona_title__Rryb6","copyright":"persona_copyright__tiL4u"};